import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CreditBundleTypeModel } from 'src/app/components/settings/credits/credit-bundle-type.model';

@Injectable({
  providedIn: 'root'
})

export class IdentityCreditsApiClient {

  constructor(private http: HttpClient) { }

  getCreditbundlesOrganisation(organisationGuid: string) {
    return this.http.get(environment.identityUrl + "/api/organisations/" + organisationGuid + "/Credits");
  }

  async postCreditBundleOrganisation(organisationGuid: string, credits: any) {
    return this.http.post(environment.identityUrl + "/api/organisations/" + organisationGuid + "/Credits", credits);
  }

  getCreditbundleTypesOrganisation(organisationGuid: string): Observable<CreditBundleTypeModel[]> {
    return this.http.get<CreditBundleTypeModel[]>(environment.identityUrl + "/api/organisations/" + organisationGuid + "/Credits/CreditbundleTypes")
  }

  async deleteCreditbundleOrganisation(organisationGuid: string, creditBundleGuid: string) {
    return this.http.delete(environment.identityUrl + "/api/organisations/" + organisationGuid + "/Credits/" + creditBundleGuid + "/delete")
  }

  getReservedCreditForOrganisation(organisationGuid: string) {
    return this.http.get<number>(environment.identityUrl + "/api/organisations/" + organisationGuid + "/Credits/ReservedCredits")
  }

  getCreditbundlesWhiteLabel(whiteLabelGuid: string) {
    return this.http.get(environment.identityUrl + "/api/whitelabels/" + whiteLabelGuid + "/Credits");
  }

  async postCreditBundleWhiteLabel(whiteLabelGuid: string, credits: any) {
    return this.http.post(environment.identityUrl + "/api/whitelabels/" + whiteLabelGuid + "/Credits", credits);
  }

  getCreditbundleTypesWhiteLabel(whiteLabelGuid: string): Observable<CreditBundleTypeModel[]> {
    return this.http.get<CreditBundleTypeModel[]>(environment.identityUrl + "/api/whitelabels/" + whiteLabelGuid + "/Credits/CreditbundleTypes")
  }

  async deleteCreditbundleWhiteLabel(whiteLabelGuid: string, creditBundleGuid: string) {
    return this.http.delete(environment.identityUrl + "/api/whitelabels/" + whiteLabelGuid + "/Credits/" + creditBundleGuid + "/delete")
  }

  getReservedCreditForWhiteLabel(whiteLabelGuid: string) {
    return this.http.get<number>(environment.identityUrl + "/api/whitelabels/" + whiteLabelGuid + "/Credits/ReservedCredits")
  }
}
